import React, { useState, useEffect } from "react";
import InvestorNavBarMain from "./InvestorNavBar";
import InvestorSideNavBar from "./SideNavBarInvestor";
import Table from "react-bootstrap/Table";
import axios from ".././axios-interceptor";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import { base_url } from './../utilities';
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { toast } from "react-toastify";
import Cookies from 'js-cookie';

const InvestorHistory = (props) => {
  const navigate = useNavigate();
  useEffect(()=>{
    if (Cookies.get("User_Accesstoken_Investor") == null) {
      navigate('/');
    }
  },[])
  const [investorHistory, setInvestorHistory] =useState([])
  const [loading, setLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });
  let ltwo = props.loading;
    useEffect(() => {
      setLoading(true);

      if(Cookies.get("investor_id")){
        axios
        .post(base_url + "investor-master/get_investor_master_user", {
          user_id: Cookies.get("investor_user_id"),
        })
        .then((res) => {
        axios
        .post(base_url + "investor-master/get_investor_history_tab",{
          "investor_id": res?.data?.data[0]?.investor_id
        })
        .then((res) => {
          setLoading(false);
          setInvestorHistory(res?.data?.data);
        })
        .catch((err) => {
          if (err.response.statusText == "Unauthorized") {
            toast.error("Your session has expired. Please login again", {
              toastId: 7,
            });
            Cookies.remove("User_Accesstoken_Investor");
            Cookies.remove("User_Refreshtoken_Investor");
            navigate("/");
          }
        });
      })
      }
        
    }, []);
  
  
    const handleSort = (column) => {
      let direction = "asc";
      if (sortOrder.column === column && sortOrder.direction === "asc") {
        direction = "desc";
      }
      setSortOrder({ column, direction  });

      const sortedData = [...investorHistory].sort((a, b) => {
        const columnA = a[column];
        const columnB = b[column];
        if (typeof columnA === "string" && typeof columnB === "string") {
          return direction === "asc"
            ? columnA.localeCompare(columnB)
            : columnB.localeCompare(columnA);
        } else if (typeof columnA === "number" && typeof columnB === "number") {
          return direction === "asc" ? columnA - columnB : columnB - columnA;
        } else {
          return 0;
        }
      });
      setInvestorHistory(sortedData);
    };


  const columns = [
    {title:"Loan Ref No", field:"loan_reference_number"},
    {title:"Cash In", field:"cash_in"},
    {title:"Cash out", field:"cash_out"},
    {title:"By Whom", field:"bywhom"},
    {title:"Paid Date", field:"last_paid_date"},
    {title:"Last Transaction", field:"created_date_time"}
  ];

  return(
    <div style={{ display: 'flex', height: '100vh' }}>
    <InvestorSideNavBar/>
    <main style={{width:"100%"}}>
    <InvestorNavBarMain/>
{loading ? <div className="d-flex justify-content-center">
                      <ThreeDots
                        height="70"
                        width="70"
                        radius="9"
                        color="#3D79F3"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                      />
                    </div>
                    : !loading && investorHistory.length !== 0 ?
    <div className={`ps-4 pe-4 mt-2 `}>
          <div className="d-flex justify-content-between mb-2">
            <div className=" d-flex gap-4 align-items-center ">
              <h1 className="">History</h1>
            </div>
          </div>
            <div className="busns_histry_table_main">
              <Table  striped  className="busns_histry_table  " >
              <thead>
                  <tr>
                    {columns.map((header, id) => {
                      return(
                        <th
                className={`Cpointer ${header.title==='Last Transaction'?'text-center':''}`}
                key={header.field}
                onClick={() => handleSort(header.field)}
              >
                {ltwo || loading ? (
                  <Skeleton width={100} height={15} />
                ) : header.title !== "Actions" ? (
                  <>
                    {" "}
                    {header.title}
                    &#9662;
                  </>
                ) : (
                  header.title
                )}
              </th>
                    )})}
                  </tr>
                </thead>
                <tbody className="">
                  {investorHistory?.map((data, index) => {
                    return (
                      <tr key={index}>
                        
                        <td > {ltwo || loading ? (
                  <Skeleton width={100} height={15} />
                ) :data.loan_reference_number === undefined ? '-' : <div className="bus_histry_tab_styl">{data.loan_reference_number}</div>}</td>
                        <td > {ltwo || loading ? (
                  <Skeleton width={100} height={15} />
                ) :data.cash_in === undefined ? '-' : '$ ' + Number(data.cash_in).toLocaleString()}</td>
                        <td > {ltwo || loading ? (
                  <Skeleton width={100} height={15} />
                ) :data.cash_out === undefined ? '-' :'$ '+ Number( data.cash_out).toLocaleString()}</td>
                        <td > {ltwo || loading ? (
                  <Skeleton width={100} height={15} />
                ) :data.by_whom === undefined ? '-' : <div className="bus_histry_LT_tab_styl">{data.by_whom}</div>}</td>
                        <td > {ltwo || loading ? (
                  <Skeleton width={100} height={15} />
                ) :data.last_paid_date === undefined ? '-' : <div className="bus_histry_LT_tab_styl">{moment(data.last_paid_date).format("DD MMM YYYY")}</div>}</td>
                        <td> {ltwo || loading ? (
                  <Skeleton width={100} height={15} />
                ) :data.created_date_time === null ? '-' : <div className=" text-center bus_histry_LT_tab_styl">{moment(data.created_date_time).format('DD MMM YYYY')} {moment(data.created_date_time).format('HH:MM:ss')}</div>}</td>
                       
                        
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
            
          </div>
          : <div className="text-center fw-bold fs-4 text-secondary mt-4">No history to display</div>
          }
    </main>
    </div>


    );
}

export default InvestorHistory;


